// extracted by mini-css-extract-plugin
export var adjacentSlide = "_nq-9";
export var arrowButtonContainer = "_nq-5";
export var arrowButtonIcon = "_nq-6";
export var carouselArrowButton = "_nq-2";
export var carouselElementContainer = "_nq-1";
export var currentSlide = "_nq-8";
export var left = "_nq-3";
export var otherSlide = "_nq-a";
export var productCarouselContainer = "_nq-0";
export var right = "_nq-4";
export var sliderOverflow = "_nq-7";